import { i18n } from "@src/i18n/i18n";
import { reminderSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

export const renderSnackbarNotificationHiddenItems = () => {
  const TIME_OUT = 10000;
  reminderSnackbar(
    i18n("modules.snackbarNotifications.hiddenItemsNotificationText"),
    TIME_OUT,
  );
};
